import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetLocationRuleSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/hooks/useGetLocationRuleSubheader';

export interface LocationsRuleHeaderProps {
  isActive: boolean;
}

export function LocationsRuleHeader({
  isActive,
}: LocationsRuleHeaderProps): JSX.Element {
  const { subheader } = useGetLocationRuleSubheader();
  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Locations"
      subheader={subheader}
    />
  );
}
